/**
 * Module emails — généré depuis le plan directeur GÉCÉRAM CRM (2026-07-28).
 * S'intègre par le registre : aucun fichier du noyau modifié.
 */
import { lazy } from "react";
import type { ModuleDef } from "../../core/module-contract";

const mod: ModuleDef = {
  id: "emails",
  label: "E-mails",
  icon: "i-mail",
  navGroup: "communications",
  navOrder: 30,
  rolesRequis: [],
  routes: [
    { path: "/emails", component: lazy(() => import("./routes/Index")) },
    // L1 : un mail entier, original dans un cadre isolé
    { path: "/emails/:id", component: lazy(() => import("./routes/Detail")) },
  ],
};

export default mod;
